<template>
  <div style="padding: 0 10px;">
    <!-- PC端 -->
    <el-container v-if="isDesktop">
      <el-row :gutter="20">
        <el-col
          v-for="(news, index) in paginatedData"
          :key="news.id"
          :span="6"
        >
            <div @click="detail((currentPage1 - 1) * pageSize + index)">
              <div class="grid-content" />
              <el-card style="max-width: 450px; height: 300px; position: relative;">
                <img
                  :src="news.image.file_path"
                  style="width: 100%; height: 150px; object-fit: cover;"
                />
                <p class="text article-title">{{ news.article_title }}</p>
                <p class="text update-time" style="position: absolute; bottom: 10px; left: 10px; ">最后更新：</p>
                <p class="text update-time" style="position: absolute; bottom: 10px; right: 10px;">{{ news.category.update_time }}</p>
              </el-card>
            </div>
        </el-col>
      </el-row>
    </el-container>

    <!-- 移动端 -->
    <el-container v-else>
      <el-row :gutter="10">
        <el-col 
          v-for="(news, index) in paginatedData"
          :key="news.id"
          :xs="24" :sm="12"
        >
            <div @click="detail((currentPage1 - 1) * pageSize + index)">
              <div class="grid-content" />
              <el-card style="max-width: 450px; height: 300px; position: relative;">
                <img
                  :src="news.image.file_path"
                  style="width: 100%; height: 150px; object-fit: cover;"
                />
                <p class="text article-title">{{ news.article_title }}</p>
                <p class="text update-time" style="position: absolute; bottom: 10px; left: 10px; ">最后更新：</p>
                <p class="text update-time" style="position: absolute; bottom: 10px; right: 10px;">{{ news.category.update_time }}</p>
              </el-card>
            </div>
          </el-col>
      </el-row>
    </el-container>

    <!-- 分页组件 -->
    <div class="block" style="display: flex; justify-content: center;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
      />
    </div>

    <!-- 弹窗 -->
    <el-dialog :visible.sync="dialogVisible" width="90%" custom-class="news-dialog" top="5vh">
      <div class="news-dialog-content">
                 <!-- 头部信息 -->
         <div class="news-header">
           <div class="header-content">
             <div class="title-section">
               <h1 class="main-title">{{ industryNew[currentIndex]?.article_title || '新闻标题' }}</h1>
               <div class="meta-info">
                 <span class="category">{{ industryNew[currentIndex]?.category?.name || '相关活动' }}</span>
                 <span class="views">{{ industryNew[currentIndex]?.show_views || 0 }}次浏览</span>
                 <span class="date">{{ industryNew[currentIndex]?.category.update_time || '' }}</span>
               </div>
             </div>
           </div>
         </div>
        
        <!-- 内容区域 -->
        <div class="news-body">
          <div class="content-container">
            <p v-html="industryNew[currentIndex]?.article_content" class="responsive-content"></p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import { industryNew,News } from '../api/api'

export default {
  name: 'News',
  data() {
    return {
      industryNew: [
        // 测试数据
        {id:1,article_title:'新闻1',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-01'}},
        {id:2,article_title:'新闻2',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-02'}},
        {id:3,article_title:'新闻3',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-03'}},
        {id:4,article_title:'新闻4',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-04'}},
        {id:5,article_title:'新闻5',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-05'}},
        {id:6,article_title:'新闻6',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-06'}},
        {id:7,article_title:'新闻7',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-07'}},
        {id:8,article_title:'新闻8',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-08'}},
        {id:9,article_title:'新闻9',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-09'}},
        {id:10,article_title:'新闻10',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-10'}},
        {id:11,article_title:'新闻11',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-11'}},
        {id:12,article_title:'新闻12',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-12'}},
        {id:13,article_title:'新闻13',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-13'}},
        {id:14,article_title:'新闻14',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-14'}},
        {id:15,article_title:'新闻15',image:{file_path:'https://via.placeholder.com/300'},category:{update_time:'2024-01-15'}}
        
      ],
      dialogVisible: false, //弹窗显示
      detailInfo: '', //详细信息
      currentPage1: 1,//当前页
      pageSize: 12,//每页数
      total: 0,//总数
      currentIndex: 0, // 当前索引
      article_content:'',//文章内容

      innerWidth: window.innerWidth,  // 维护一个响应式的窗口内宽度
    }
  },
  methods: {
    async getIndustryNew(page = 1) {
      const data = {
        token: "",
        wxapp_id: '10001'
        // page: page,
        // page_size: this.pageSize
      }
      industryNew(data).then(response => {
        // console.log(response);
        this.industryNew = response.data.data.list.data
        this.total = response.data.data.list.total
        this.article_content=response.data.data.list.data[2].article_content
        // console.log('response--+++++------');
        // console.log(this.industryNew[0].article_title);
        // console.log(this.industryNew[0].image.file_path);
        // News请求处理
          News(data).then(response => {
              const newsData = response.data.data.list.data;
              // 将新数据追加到现有数组
              // console.log('-------2');
              // console.log(newsData);

              this.industryNew = [...this.industryNew, ...newsData]         
              this.total += response.data.data.list.total;
          }).catch(error => {
              console.error('News请求失败:', error);
          });
      }).catch(error => {
        console.error(error);
      });

      

    },
   handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage1 = 1; // 切换每页数量时，最好回到第一页
    },
    handleCurrentChange(newPage) {
      // 当使用计算属性时，这里只需要更新页码即可
      // Vue的响应式系统会自动更新视图
      this.currentPage1 = newPage;
    },
    detail(index) {
      // console.log('点击的项在原数组中的真实索引是:', index);
      this.currentIndex = index;
      this.dialogVisible = !this.dialogVisible;
    },

    updateInnerWidth() {
    this.innerWidth = window.innerWidth;
    },

  },

  computed: {
    paginatedData() {
      // 计算当前页的起始索引
      const start = (this.currentPage1 - 1) * this.pageSize;
      // 计算当前页的结束索引
      const end = start + this.pageSize;
      // 使用 Array.prototype.slice() 从完整数据中提取当前页的数据
      return this.industryNew.slice(start, end);
    },
    isMobile() {
      return this.innerWidth <= 1023;  // 根据需要调节阈值
    },
    isDesktop() {
      return this.innerWidth > 1023;
    }
  },

  created() {
    this.getIndustryNew()
  //  this.total = this.industryNew.length //根据静态数据长度设置总数
  
    window.addEventListener('resize', this.updateInnerWidth)
        // this.total = this.industryNew.length
  }
}
</script>

<style>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 15px;
}

.article-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.update-time {
  color: #999;
  text-align: left;
}

/* 响应式样式 */
.content-container {
    max-height: none;
    overflow-y: visible;
}

/* 内容格式化样式 */
.responsive-content {
    /* 基础样式 */
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    
    /* 重置所有元素样式 */
    * {
        max-width: 100%;
        margin: 0.8em 0;
        line-height: inherit;
        box-sizing: border-box;
    }

    /* 处理常见HTML元素 */
    h1, h2, h3, h4, h5, h6 {
        font-weight: 600;
        line-height: 1.3;
    }

    img {
        height: auto !important;
        display: block;
        margin: 1em auto;
        max-width: 95% !important;
    }

    table {
        width: 100% !important;
        border-collapse: collapse;
        margin: 1.5em 0;
        
        td, th {
            padding: 8px;
            border: 1px solid #ddd;
        }
    }

    ul, ol {
        padding-left: 2em;
    }

    code {
        background: #f5f5f5;
        padding: 0.2em 0.4em;
        border-radius: 3px;
    }

    pre {
        background: #f5f5f5;
        padding: 1em;
        overflow-x: auto;
        white-space: pre-wrap;
        word-wrap: break-word;
        
        code {
            background: none;
            padding: 0;
        }
    }

    /* 移动端适配 */
    @media (max-width: 768px) {
        font-size: 14px;
        
        img {
            max-width: 100% !important;
        }
    }
}

.responsive-content {
    word-wrap: break-word;
    white-space: pre-wrap;
    line-height: 1.6;
}

/* 新闻弹窗样式 */
.news-dialog {
  max-width: 1000px !important;
  width: 90% !important;
}

.el-dialog__body{
  padding: 20px 10px;
}

.news-dialog-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #f8f9fa;
}

/* 头部样式 */
.news-header {
  background-color: white;
  padding: 25px;
  border-radius: 8px 8px 0 0;
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  .header-content {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    
  }
  
  .title-section {
    max-width: 800px;
    
    .main-title {
      font-size: 22px;
      font-weight: bold;
      color: #333;
      margin: 0 0 15px 0;
      line-height: 1.4;
      word-wrap: break-word;
    }
    
    .meta-info {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      color: #666;
      font-size: 14px;
      
      .category {
        color: #FF6600;
        font-weight: 500;
        
      }
      
      .views, .date {
        color: #999;
        font-weight: 500;

      }
    }
  }
  
  .logo-section {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 120px;
    
    .logo-icon {
      position: relative;
      width: 40px;
      height: 40px;
      
      .icon-square {
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #FF6600;
        border-radius: 2px;
      }
      
      .icon-square:first-child {
        top: 0;
        left: 0;
      }
      
      .icon-square:nth-child(2) {
        top: 0;
        right: 0;
      }
      
      .icon-magnifier {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 16px;
        height: 16px;
        border: 2px solid #FF6600;
        border-radius: 50%;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -4px;
          right: -4px;
          width: 6px;
          height: 2px;
          background-color: #FF6600;
          transform: rotate(45deg);
        }
      }
    }
    
    .logo-text {
      color: #333;
      font-weight: 500;
      font-size: 14px;
    }
  }
}

/* 内容区域样式 */
.news-body {
  background-color: white;
  flex: 1;
  /* padding: 25px; */
  border-radius: 0 0 8px 8px;
  overflow-y: visible;
  width: 100%;
  box-sizing: border-box;
  margin-top: 1px;
  
  .article-content {
    font-family: "Microsoft YaHei", "Helvetica Neue", Arial, sans-serif;
    font-size: 16px;
    line-height: 1.8;
    color: #333;
    
    img {
      max-width: 100%;
      height: auto;
      border-radius: 8px;
      margin: 15px 0;
    }
    
    p {
      margin: 15px 0;
    }
    
    h1, h2, h3, h4, h5, h6 {
      color: #333;
      margin: 20px 0 15px 0;
    }
  }
}


/* 手机端适配  */
@media (max-width: 768px) {
  /*======== 弹窗容器整体控制 ========*/
  .news-dialog {
    width: 95% !important;
    max-width: 95% !important;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    margin-top: 5vh !important;
  }

  .news-dialog .el-dialog__body {
    padding: 0;
    flex: 1;
    min-height: 0;
    display: flex;
  }

  .news-dialog-content {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  /*======== 头部样式精确修正 ========*/
  .news-header {
    padding: 15px 10px;
    flex-shrink: 0;
  }
  
  .news-header .header-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .news-header .title-section {
    text-align: center;
  }
  
  .news-header .title-section .main-title {
    font-size: 18px;
    margin: 0 0 10px 0;
  }

  .news-header .title-section .meta-info {
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center; /* 确保无论是否换行，内容都居中 */
    gap: 15px; /* 控制span之间的间距 */
     
    /* 禁止iOS字体大小自动调整，确保万无一失 */
    -webkit-text-size-adjust: 100%;
  }

  .category {
        color: #FF6600;
        font-weight: 500;
  }
      

  /*======== 内容区布局 ========*/
  .news-body {
    padding: 1px 10px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    width: 100%;
    box-sizing: border-box;
  }
  
  /*======== 富文本内容强制响应式 ========*/
  .responsive-content * {
    max-width: 100% !important;
    box-sizing: border-box; 
    height: auto !important;
  }
  .responsive-content {
     word-wrap: break-word;
     overflow-wrap: break-word;
   }
  
   .news-body .article-content, 
  .news-body .responsive-content p {
    font-size: 14px;
    line-height: 1.6;
    margin: 10px 0;
  }
}





</style>